import React from 'react';
import { Tabs } from 'antd';
import { Navigate } from 'react-router-dom';
import { TeamOutlined, CloudDownloadOutlined, DollarOutlined } from '@ant-design/icons';
import UsersAdminTab from './admin/UsersAdminTab';
import DataExportsTab from './admin/DataExportsTab';
import BasePriceVersionsTab from './admin/BasePriceVersionsTab';

const AdminPage: React.FC = () => {
  const userDetailsRaw = localStorage.getItem('user_details');
  const features: string[] = userDetailsRaw ? JSON.parse(userDetailsRaw).features || [] : [];

  if (!features.includes('FE_ADMIN')) {
    return <Navigate to="/home" />;
  }

  return (
    <div style={{ padding: '24px' }}>
      <h1 style={{ marginBottom: 16 }}>Admin</h1>
      <Tabs
        defaultActiveKey="users"
        size="large"
        items={[
          {
            key: 'users',
            label: (
              <span>
                <TeamOutlined /> Users
              </span>
            ),
            children: <UsersAdminTab />,
          },
          {
            key: 'data-exports',
            label: (
              <span>
                <CloudDownloadOutlined /> Data Exports
              </span>
            ),
            children: <DataExportsTab />,
          },
          {
            key: 'base-price-versions',
            label: (
              <span>
                <DollarOutlined /> Base Price Versions
              </span>
            ),
            children: <BasePriceVersionsTab />,
          },
        ]}
      />
    </div>
  );
};

export default AdminPage;
